export const ALL_PROJECTS_VIEW = {
  PROJECTS_VIEW_SELECTION_WRAPPER: 'projectsViewSelectionWrapper',
  CARD_ICON_TEST_ID: 'selectionCardIcon',
  TABULAR_ICON_TEST_ID: 'selectionTabularIcon',
  CELL_RENDERERS: {
    NAME_CELL_RENDERER: {
      PROJECT_NAME_WRAPPER: 'allProjectsProjectNameWrapper'
    },
    ROW_NUMBER_CELL_RENDERER: {
      ROW_NUMBER_CELL_RENDERER_WRAPPER: 'allProjectsRowNumberCellRendererWrapper'
    },
    STATUS_CELL_RENDERER: {
      WRAPPER: 'allProjectsStatusCellRendererWrapper'
    },
    TYPE_CELL_RENDERER: {
      WRAPPER: 'allProjectsTypeCellRendererWrapper'
    },
    START_DATE_CELL_RENDERER: {
      WRAPPER: 'allProjectsStartDateCellRendererWrapper'
    },
    FINISH_DATE_CELL_RENDERER: {
      WRAPPER: 'allProjectsFinishDateCellRendererWrapper'
    },
    PERCENT_COMPLETE_CELL_RENDERER: {
      WRAPPER: 'allProjectsPercentCompleteCellRendererWrapper'
    },
    DURATION_CELL_RENDERER: {
      WRAPPER: 'allProjectsDurationCellRendererWrapper'
    },
    USER_COUNT_CELL_RENDERER: {
      WRAPPER: 'allProjectsUserCountCellRendererWrapper'
    },
    VERSION_CELL_RENDERER: {
      WRAPPER: 'allProjectsVersionCellRendererWrapper'
    },
    LAST_MODIFIED_CELL_RENDERER: {
      WRAPPER: 'allProjectsLastModifiedCellRendererWrapper'
    },
    ORGANIZATION_FIELD_CELL_RENDERER: {
      WRAPPER: 'allProjectsOrganizationFieldCellRendererWrapper'
    }
  },
  ORGANIZE_BY: {
    FIRST_SELECT: 'allProjectsOrganizeByFirstSelect',
    SECOND_SELECT: 'allProjectsOrganizeBySecondSelect'
  }
} as const;
